import React, { ReactElement } from 'react'
import {
    PaginationListItem,
    StyledPaginationItem,
    StyledPaginationLink,
    StyledText,
} from '../Pagination.styled'
import { DisplayProperty } from 'csstype'
import { BreakpointState, ThemeConfig } from '../../../__styling'
import { DataLayerEventName } from '@news-mono/web-common'

export type DisplayProps = BreakpointState<
    ThemeConfig,
    {
        display: DisplayProperty
    }
>
export type PaginationItemProps = {
    text?: string
    isDisabled: boolean
    layout: {
        showText: boolean
        hideTextAtMobile?: boolean
        display: DisplayProps
    }
    onClick: (e: number) => void
    onEvent: (event: any) => void
    routePath: string
    params?: string
    page: {
        currentPage: number
        nextPage: number
    }
    icon?: {
        iconElement: ReactElement
        iconPosition: 'before' | 'after'
    }
    flexGrow?: boolean
}

export const PaginationItem = ({
    text,
    isDisabled,
    layout,
    onClick,
    routePath,
    params,
    page,
    icon,
    flexGrow,
    onEvent,
}: PaginationItemProps) => {
    const isCurrentPage = page.currentPage === page.nextPage

    // append the parameters, if provided
    const path = params ? `${routePath}?${params}` : routePath
    const nextPagePath = params
        ? `${path}&page=${page.nextPage}`
        : `${path}?page=${page.nextPage}`

    const route = page.nextPage === 1 ? path : nextPagePath

    const ariaCurrent = isCurrentPage ? 'page' : undefined
    const ariaLabel = `Goto Page ${text ? text : page.nextPage}`
    const tabIndex = isDisabled ? -1 : undefined

    const handleClick = () => {
        onEvent({
            type: DataLayerEventName.linkClicked,
            originator: 'TheNightlyPagination',
            payload: {
                current_page: `${page.currentPage}`,
                next_page: `${page.nextPage}`,
            },
        })
        onClick(page.nextPage)
    }
    const content = (
        <>
            {icon?.iconPosition === 'before' && icon.iconElement}
            <StyledText hideTextAtMobile={layout.hideTextAtMobile}>
                {layout.showText ? (text ? text : page.nextPage) : null}
            </StyledText>
            {icon?.iconPosition === 'after' && icon.iconElement}
        </>
    )
    return (
        <>
            {isDisabled ? (
                <PaginationListItem
                    aria-hidden="true"
                    display={layout.display}
                    flexGrow={flexGrow}
                >
                    <StyledPaginationItem
                        display={layout.display}
                        tabIndex={tabIndex}
                        onClick={handleClick}
                        hasIcon={icon !== undefined}
                        className="disabled"
                    >
                        {content}
                    </StyledPaginationItem>
                </PaginationListItem>
            ) : (
                <PaginationListItem
                    aria-label={ariaLabel}
                    aria-current={ariaCurrent}
                    display={layout.display}
                    flexGrow={flexGrow}
                >
                    <StyledPaginationLink
                        to={route}
                        display={layout.display}
                        onClick={handleClick}
                        hasIcon={icon !== undefined}
                        className={isCurrentPage ? 'enabled-active' : 'enabled'}
                    >
                        {content}
                    </StyledPaginationLink>
                </PaginationListItem>
            )}
        </>
    )
}
